import type { Translation } from '../types.ts';
import type en from '../en/customers.ts';

export default {
    status: {
        active: 'Actief',
        disabled: 'Geblokkeerd',
        deleted: 'Verwijderd',
        verified: 'Bevestigd',
        unverified: 'Niet bevestigd',
    },
    shared: {
        company: 'Bedrijf',
        locale: 'Taal',
        joined: 'Lid sinds',
        lastLogin: 'Laatst ingelogd',
    },
    list: {
        title: 'Klanten',
        search: 'Zoeken op e-mail, naam, bedrijf of btw-nummer…',
        includeDeleted: 'Verwijderde tonen',
        empty: 'Nog geen klanten.',
    },
    edit: {
        restore: 'Terugzetten',
        profile: 'Profiel',
        firstName: 'Voornaam',
        lastName: 'Achternaam',
        vatNumber: 'Btw-nummer',
        marketingOptIn: 'Toestemming voor marketing',
        disabled: 'Geblokkeerd',
        groups: 'Groepen',
        groupsHelp: 'Groepen bepalen welke afgeschermde pagina\'s, artikelen en producten deze klant kan zien. Wordt opgeslagen met de rest van het profiel.',
        noGroups: 'Nog geen groepen op deze website.',
        addresses: 'Adressen',
        noAddresses: 'Geen adressen bekend. De klant voegt die toe vanuit zijn account.',
        addressShipping: 'verzendadres',
        addressBilling: 'factuuradres',
        addressVat: 'Btw: {number}',
        account: 'Account',
        termsAccepted: 'Voorwaarden geaccepteerd',
        adminActions: 'Beheeracties',
        adminActionsHelp: 'Wij zien of wijzigen nooit zelf wachtwoorden. De klant rondt het af via e-mail.',
        resendVerification: 'Bevestigingsmail opnieuw versturen',
        sendPasswordReset: 'Wachtwoordreset versturen',
        verificationSent: 'Bevestigingsmail verstuurd',
        confirmPasswordReset: 'Een e-mail om het wachtwoord opnieuw in te stellen naar {email} sturen?',
        passwordResetSent: 'E-mail voor wachtwoordreset verstuurd',
        confirmDelete: '{email} verwijderen? Deze klant kan dan niet meer inloggen. Je kunt de klant later terugzetten.',
        deleted: 'Klant verwijderd',
        restored: 'Klant teruggezet',
    },
    groups: {
        title: 'Klantgroepen',
        groups: 'Groepen',
        help: 'Groepen bepalen wie afgeschermde pagina\'s, artikelen, producten en menu-items kan zien. Zet klanten in een groep vanaf hun eigen pagina; kies de groep bij de inhoud die je wilt afschermen.',
        empty: 'Nog geen groepen.',
        members: '{n} leden | {n} lid | {n} leden',
        slugHint: 'Thema\'s testen op deze naam',
        slugHintNew: 'Optioneel, afgeleid van de naam',
        newGroup: 'Nieuwe groep',
        create: 'Groep aanmaken',
        created: 'Groep aangemaakt',
        saved: 'Groep opgeslagen',
        deleted: 'Groep verwijderd',
        loadFailed: 'Klantgroepen konden niet worden geladen.',
        createFailed: 'De groep kon niet worden aangemaakt.',
        saveFailed: 'De groep kon niet worden opgeslagen.',
        deleteFailed: 'De groep kon niet worden verwijderd.',
        confirmDelete: '"{name}" verwijderen?\n\nElke pagina, elk artikel, product of menu-item dat alleen voor deze groep is, wordt voor niemand meer zichtbaar totdat je de toegang aanpast.',
    },
    access: {
        public: 'Iedereen',
        authenticated: 'Ingelogde klanten',
        groups: 'Geselecteerde klantgroepen',
    },
    settings: {
        sender: 'Afzender voor klantmails',
        senderHelp: 'Optioneel: een andere afzender voor bevestigings- en wachtwoordresetmails. Laat leeg om de standaardafzender van de website te gebruiken.',
        fromEmail: 'Afzender e-mail',
        fromName: 'Afzendernaam',
        defaultEmailMissing: 'Stel eerst de standaard van de website in',
        defaultNameFallback: 'Valt terug op de standaard van de website',
        save: 'Klantinstellingen opslaan',
    },
} satisfies Translation<typeof en>;
